<template>
<v-container fluid class="bank-print-page pa-3 pa-md-5">
  <div class="d-flex align-center mb-5">
    <v-icon color="primary" large class="ml-3">
      mdi-bank-transfer
    </v-icon>

    <div class="text-h5 font-weight-medium">
      حواله بین بانکی ملت
    </div>
  </div>

  <v-form ref="form" v-model="valid" lazy-validation>
    <v-card outlined>
      <v-card-text class="pa-4 pa-md-5">
        <!-- حساب مبدأ -->
        <div class="section-title">
          <v-icon class="ml-2">mdi-bank</v-icon>
          حساب مبدأ
        </div>

        <v-row>
          <v-col cols="12" md="4">
            <v-text-field v-model="form.address" label="نشانی" prepend-inner-icon="mdi-map-marker" underlined />
          </v-col>

          <v-col cols="12" md="4">
            <v-text-field v-model="form.phone" label="تلفن ثابت" prepend-inner-icon="mdi-phone" maxlength="20" type="tel" underlined />
          </v-col>

        </v-row>

        <v-row>
          <v-col cols="12" md="4">
            <MyBankaccounts ref="sourceAccountField" v-model="form.sourceAccountId" label="انتخاب حساب بانکی مبدأ" :rules="requiredRules" @selected="onSourceAccountSelected" />
          </v-col>
        </v-row>

        <v-divider class="my-5" />

        <!-- اطلاعات حواله -->
        <div class="section-title">
          <v-icon class="ml-2">mdi-cash-fast</v-icon>
          اطلاعات حواله
        </div>

        <v-row>
          <v-col cols="12" md="4">
            <MyCurrency v-model="form.amount" label="مبلغ حواله (ریال)" :rules="requiredRules" underlined />
          </v-col>
          <v-col cols="12" md="4">
            <MyDate v-model="form.date" label="تاریخ" :rules="requiredRules" underlined @setValue="form.date = $event" />
          </v-col>

          <v-col cols="12" md="4">
            <v-text-field v-model="form.reason" label="بابت" prepend-inner-icon="mdi-text" underlined />
          </v-col>

          <v-row v-if="normalizedAmount" align="center" class="amount-summary">
            <!-- سمت چپ: مبلغ عددی -->
            <v-col cols="12" md="4" class="text-left">
              <div class="amount-in-words">
                <!-- <span class="amount-in-words-label">مبلغ به عدد:</span> -->
                <span>{{ amountInTomanFormatted }} تومان</span>
              </div>
            </v-col>
            <!-- سمت راست: مبلغ به حروف -->
            <v-col cols="12" md="8" class="text-right">
              <div class="amount-in-words">
                <span class="amount-in-words-label">مبلغ به حروف:</span>
                <span>{{ amountInWordsToman }} تومان</span>
              </div>
            </v-col>

          </v-row>
        </v-row>

        <v-divider class="my-5" />

        <!-- اطلاعات ذینفع -->
        <div class="section-title">
          <v-icon class="ml-2">mdi-account-arrow-left</v-icon>
          اطلاعات ذینفع
        </div>

        <v-row>
          <!-- <v-col cols="12" md="4">
            <MyBanks v-model="form.destinationBankId" :required="false" @selected="onDestinationBankSelected" />
          </v-col> -->

          <v-col cols="12" md="4">
            <v-text-field v-model="form.sheba" label="شبای حساب ذینفع" v-mask="'IR## #### #### #### #### #### ##'" type="text" dir="ltr" underlined :rules="shebaRules" :success="isShebaValidValue" :success-messages="[]"
              :error="isShebaComplete && !isShebaValidValue" :error-messages="[]">
              <template v-slot:append>
              <v-icon v-if="isShebaValidValue" color="success">
                mdi-check-circle
              </v-icon>
            </template>
            </v-text-field>

            <div v-if="isShebaComplete && isShebaValidValue && shebaBankInfo" class="sheba-bank-info">
              <v-icon small color="success" class="ml-1">
                mdi-bank-check
              </v-icon>

              <span>{{ shebaBankInfo.persianName }}</span>
            </div>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field v-model="form.beneficiaryName" label="نام ذینفع" prepend-inner-icon="mdi-account" underlined :rules="requiredRules" />
          </v-col>

          <!-- <v-col cols="12" md="4" class="">
            <v-text-field v-model="form.sheba" label="شبای حساب ذینفع" v-mask="'IR## #### #### #### #### #### ##'" type="text" dir="ltr" underlined :rules="shebaRules" />
          </v-col> -->
        </v-row>
      </v-card-text>

      <v-divider />

      <v-card-actions class="pa-4 justify-start">
        <v-btn color="primary" large @click="printForm">
          <v-icon right>mdi-printer</v-icon>
          چاپ حواله(Ctrl+P)
        </v-btn>

        <v-btn color="secondary" large text class="ml-2" @click="resetForm">
          <v-icon right>mdi-refresh</v-icon>
          پاک کردن فرم
        </v-btn>

        <v-btn color="error" variant="outlined" @click="goToDashboard">
          <v-icon start>mdi-exit-to-app</v-icon>
          خروج
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</v-container>
</template>

<script>
import {
  numberToWords,
  isShebaValid,
  getShebaInfo,
} from '@persian-tools/persian-tools'

import MyBankaccounts from '@/components/MyBankaccounts.vue'
// import MyBanks from '@/components/MyBanks.vue'
import MyCurrency from '@/components/MyCurrency.vue'
import MyDate from '@/components/MyDate.vue'

import {
  toJalaali
} from '@/functions/myDate'

const DEFAULT_PHONE = '۳۳۶۴۱۹۸۶'
const DEFAULT_ADDRESS = 'بازار رضا پلاک ۲/۶۰۵'

const PRINT_LAYOUT = {
  date: {
    left: 10,
    top: 15,
    width: 28,
    fontSize: 9,
    align: 'left',
  },
  branch: {
    left: 10,
    top: 20,
    width: 28,
    fontSize: 9,
    align: 'left',
  },
  owner: {
    left: 62, //65
    top: 32,
    width: 35,
    fontSize: 10,
    align: 'right',
  },
  nationalCode: {
    left: 10,
    top: 32, //32
    width: 25,
    fontSize: 9,
    align: 'left',
  },
  sourceAccountNumber: {
    left: 60,
    top: 40,
    width: 47,
    fontSize: 10,
    align: 'left',
  },
  phone: {
    left: 10,
    top: 40,
    width: 26,
    fontSize: 9,
    align: 'left',
  },
  address: {
    left: 5,
    top: 46,
    width: 90,
    fontSize: 8,
    align: 'right',
  },
  reason: {
    left: 35, //15
    top: 53,
    width: 72,
    fontSize: 9,
    align: 'right',
  },
  amount: {
    left: 10,
    top: 53,
    width: 47,
    fontSize: 12,
    align: 'left',
  },
  amountInWords: {
    left: 3, //5
    top: 61,
    width: 96,
    fontSize: 7,
    align: 'right',
  },
  destinationBank: {
    left: 70, //45
    top: 85,
    width: 30,
    fontSize: 8,
    align: 'right',
  },
  beneficiaryName: {
    left: 25, //10
    top: 85,
    width: 35,
    fontSize: 8,
    align: 'right',
  },
  sheba: {
    left: 17,
    top: 92,
    width: 105,
    fontSize: 14,
    align: 'left',
  },
}
// const PRINT_TEST = {
//   sourceAccountId: null,
//
//   phone: DEFAULT_PHONE,
//   address: DEFAULT_ADDRESS,
//
//   date: '',
//   reason: 'خرید نقره',
//   amount: '15565000000',
//
//   destinationBankId: null,
//   beneficiaryName: 'سیدامیر حسین موسوی  ',
//   sheba: '140736927600000000012076',
// }

function toEnglishDigits(value) {
  return String(value == null ? '' : value)
    .replace(/[۰-۹]/g, digit =>
      String('۰۱۲۳۴۵۶۷۸۹'.indexOf(digit))
    )
    .replace(/[٠-٩]/g, digit =>
      String('٠١٢٣٤٥٦٧٨٩'.indexOf(digit))
    )
}

function toPersianDigits(value) {
  return toEnglishDigits(value).replace(
    /\d/g,
    digit => '۰۱۲۳۴۵۶۷۸۹' [Number(digit)]
  )
}

export default {
  name: 'BankPrint',

  components: {
    MyBankaccounts,
    // MyBanks,
    MyCurrency,
    MyDate,
  },

  data() {
    return {
      valid: false,

      requiredRules: [
        v =>
        !!String(v == null ? '' : v).trim() ||
        'این فیلد الزامی است',
      ],
      shebaRules: [
        v => {
          const normalized = toEnglishDigits(v)
            .replace(/\s/g, '')
            .toUpperCase()

          if (!normalized) {
            return 'وارد کردن شبای ذی‌نفع الزامی است'
          }

          if (!/^IR\d{24}$/.test(normalized)) {
            return 'شبا باید شامل IR و دقیقاً ۲۴ رقم باشد'
          }

          try {
            return (
              isShebaValid(normalized) ||
              'شماره شبا معتبر نیست'
            )
          } catch (error) {
            return 'شماره شبا معتبر نیست'
          }
        },
      ],
      // form: PRINT_TEST,
      form: {
        sourceAccountId: null,

        phone: DEFAULT_PHONE,
        address: DEFAULT_ADDRESS,

        date: '',
        reason: 'خرید نقره',
        amount: '',

        // destinationBankId: null,
        beneficiaryName: '',
        sheba: '',
      },

      sourceAccount: {},
      // destinationBank: {},
    }
  },

  computed: {
    normalizedAmount() {
      return toEnglishDigits(this.form.amount)
        .replace(/\D/g, '')
        .replace(/^0+/, '')
    },

    formattedAmount() {
      if (!this.normalizedAmount) {
        return '۰'
      }

      return Number(this.normalizedAmount).toLocaleString('fa-IR')
    },

    amountInWords() {
      if (!this.normalizedAmount) {
        return 'صفر'
      }

      return numberToWords(Number(this.normalizedAmount))
    },

    amountInWordsToman() {
      if (!this.normalizedAmount) {
        return 'صفر'
      }

      const amountInToman = Math.floor(
        Number(this.normalizedAmount) / 10
      )

      return numberToWords(amountInToman)
    },

    amountInTomanFormatted() {
      const amount = Math.floor(Number(this.normalizedAmount) / 10)

      return amount.toLocaleString('fa-IR')
    },

    normalizedSheba() {
      return toEnglishDigits(this.form.sheba)
        .replace(/\s/g, '')
        .toUpperCase()
    },

    // destinationBankName() {
    //   const title = String(this.destinationBank.title || '').trim()
    //
    //   return title.replace(
    //     /^\s*[\d۰-۹٠-٩]+\s*[-–—]\s*/,
    //     ''
    //   )
    // },

    isShebaComplete() {
      return /^IR\d{24}$/.test(this.normalizedSheba)
    },

    isShebaValidValue() {
      if (!this.isShebaComplete) {
        return false
      }

      try {
        return isShebaValid(this.normalizedSheba)
      } catch (error) {
        return false
      }
    },

    shebaBankInfo() {
      if (!this.isShebaValidValue) {
        return null
      }

      try {
        return getShebaInfo(this.normalizedSheba)
      } catch (error) {
        return null
      }
    },
  },

  created() {
    this.form.date = toJalaali(new Date()).date
  },

  mounted() {
    this.focusSourceAccount()

    document.addEventListener(
      'keydown',
      this.handlePrintShortcut,
      true
    )
  },

  beforeDestroy() {
    document.removeEventListener(
      'keydown',
      this.handlePrintShortcut,
      true
    )
  },

  methods: {
    goToDashboard() {
      // this.$router.push('/dashboard')
      this.$router.back()
    },

    handlePrintShortcut(event) {
      // خروج با کلید Escape
      if (event.key === 'Escape') {
        event.preventDefault()
        event.stopImmediatePropagation()

        this.goToDashboard()
        return
      }

      // چاپ با Ctrl + P یا Cmd + P
      const isPrintShortcut =
        (event.ctrlKey || event.metaKey) &&
        String(event.key || '').toLowerCase() === 'p'

      if (!isPrintShortcut) {
        return
      }

      event.preventDefault()
      event.stopImmediatePropagation()

      this.printForm()
    },

    formatShebaForPrint(value) {
      const digits = toEnglishDigits(value)
        .replace(/^IR/i, '')
        .replace(/\D/g, '')

      if (digits.length !== 24) {
        return toPersianDigits(digits)
      }

      const groups = [
        digits.slice(0, 2),
        digits.slice(2, 6),
        digits.slice(6, 10),
        digits.slice(10, 14),
        digits.slice(14, 18),
        digits.slice(18, 22),
        digits.slice(22, 24),
      ]

      return groups
        .map(group => toPersianDigits(group))
        .join(' ')
    },

    focusSourceAccount() {
      this.$nextTick(() => {
        const component = this.$refs.sourceAccountField

        if (
          component &&
          component.$refs &&
          component.$refs.list
        ) {
          component.$refs.list.focus()
        }
      })
    },

    onSourceAccountSelected(account) {
      this.sourceAccount = account ? {
        ...account
      } : {}
    },

    // onDestinationBankSelected(bank) {
    //   this.destinationBank = bank ? {
    //     ...bank
    //   } : {}
    // },

    printForm() {
      if (!this.$refs.form.validate()) {
        return
      }

      const fields = {
        date: toPersianDigits(this.form.date),

        branch: toPersianDigits(
          this.sourceAccount.branch
        ),

        owner: this.sourceAccount.owner || '',

        nationalCode: toPersianDigits(
          this.sourceAccount.national_code
        ),

        sourceAccountNumber: toPersianDigits(
          this.sourceAccount.number
        ),

        phone: toPersianDigits(this.form.phone),

        address: this.form.address,

        reason: this.form.reason,

        amount: this.normalizedAmount ?
          `**///${this.formattedAmount}ریال` : '',

        amountInWords: this.normalizedAmount ?
          `${this.amountInWords} ریال` : '',

        // destinationBank: this.destinationBankName,
        destinationBank: this.shebaBankInfo ?
          this.shebaBankInfo.persianName : '',

        beneficiaryName: this.form.beneficiaryName,

        sheba: this.formatShebaForPrint(this.normalizedSheba),
      }

      const printWindow = window.open(
        '',
        '_blank')

      if (!printWindow) {
        alert('پنجره چاپ باز نشد. لطفاً اجازه باز شدن پنجره جدید را بدهید.')
        return
      }

      const fieldsHtml = Object.keys(PRINT_LAYOUT)
        .map(key => {
          const value = fields[key]

          if (
            value === null ||
            value === undefined ||
            value === ''
          ) {
            return ''
          }

          const config = PRINT_LAYOUT[key]

          const isSheba = key === 'sheba'

          const text = String(value)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;')

          const fieldContent = isSheba ?
            String(value)
            .split(' ')
            .map(group => {
              return `<span class="sheba-group" dir="ltr">${group}</span>`
            })
            .join('<span class="sheba-space">&nbsp;</span>') :
            text
          // class="print-field ${isSheba ? 'ltr' : 'rtl'}"
          // ${key === 'amount' ? 'font-weight: bold;' : ''}
          return `
            <div
              class="print-field ${isSheba ? 'sheba' : 'rtl'}"
              style="
                left: ${config.left}mm;
                top: ${config.top}mm;
                width: ${config.width}mm;
                font-size: ${config.fontSize}pt;
                text-align: ${config.align};
                ${isSheba ? 'letter-spacing: 0.6mm; word-spacing: 2mm;' : ''}
              "
            >${fieldContent}</div>
          `
        })
        .join('')

      const html = `
    <!DOCTYPE html>
    <html lang="fa" dir="rtl">
    <head>
      <meta charset="UTF-8">

      <title>چاپ حواله بین بانکی ملت</title>

      <style>
        @page {
          size: A4 portrait;
          margin: 0;
        }

        * {
          box-sizing: border-box;
        }

        html,
        body {
          margin: 0;
          padding: 0;
          width: 210mm;
          min-height: 297mm;
          direction: rtl;
        }

        body {
          font-family: IRANSans, Tahoma, sans-serif;
          color: #000;
        }

        .print-sheet {
          position: relative;
          width: 210mm;
          height: 297mm;
          overflow: hidden;
          background: #fff;
        }

        .print-field {
          position: absolute;
          line-height: 1.4;
          white-space: nowrap;
          color: #000;
          margin: 0;
          padding: 0;
        }

        .print-field.rtl {
          direction: rtl;
          unicode-bidi: plaintext;
        }

        .print-field.ltr {
          direction: ltr;
          unicode-bidi: isolate;
          text-align: left;
        }

        .print-field.sheba {
          direction: ltr;
          unicode-bidi: isolate;
          text-align: left;
          white-space: nowrap;
          letter-spacing: 0;
          word-spacing: 0;
        }

        .print-field.sheba .sheba-group {
          display: inline-block;
          direction: ltr;
          unicode-bidi: isolate;
        }

        .print-field.sheba .sheba-space {
          display: inline-block;
          width: 1.5mm;
        }

        @media screen {
          body {
            background: #eee;
          }

          .print-sheet {
            margin: 10px auto;
            box-shadow: 0 0 5px #999;
          }
        }

        @media print {
          html,
          body {
            width: 210mm;
            height: 297mm;
          }

          .print-sheet {
            margin: 0;
            box-shadow: none;
          }
        }
      </style>
    </head>

    <body>
      <div class="print-sheet">
        ${fieldsHtml}
      </div>

      <script>
        window.onload = function () {
          window.focus();

          setTimeout(function () {
            window.print();
          }, 300);
        };
      ${'<' + '/script>'}
    </body>
    </html>
  `

      printWindow.document.open()
      printWindow.document.write(html)
      printWindow.document.close()
    },

    resetForm() {
      this.form = {
        sourceAccountId: null,

        phone: DEFAULT_PHONE,
        address: DEFAULT_ADDRESS,

        date: toJalaali(new Date()).date,
        reason: 'خرید نقره',
        amount: '',

        // destinationBankId: null,
        beneficiaryName: '',
        sheba: '',
      }

      this.sourceAccount = {}
      this.destinationBank = {}

      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetValidation()
        }

        this.focusSourceAccount()
      })
    },
  },
}
</script>

<style scoped>
.bank-print-page {
  direction: rtl;
  text-align: right;
}

.section-title {
  display: flex;
  align-items: center;
  font-size: 17px;
  font-weight: 600;
  margin-bottom: 18px;
  color: var(--v-primary-base);
}

.section-title .v-icon {
  font-size: 23px;
}

.amount-in-words {
  margin-top: 4px;
  padding: 10px 12px;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.035);
  font-size: 22px;
  line-height: 1.9;
  overflow-wrap: anywhere;
}

.amount-in-words-label {
  font-weight: 600;
  margin-left: 6px;
}

@media (max-width: 600px) {
  .bank-print-page {
    padding: 8px !important;
  }

  .section-title {
    font-size: 16px;
  }
}

.print-field.sheba {
  direction: rtl;
  unicode-bidi: isolate;
  text-align: right;
  white-space: nowrap;
  letter-spacing: 0;
  word-spacing: 0;
}

.sheba-bank-info {
  display: flex;
  align-items: center;
  margin-top: -12px;
  padding: 0 12px;
  color: var(--v-success-base);
  font-size: 13px;
  min-height: 24px;
}
</style>
